import yup from 'src/libs/yup';

export const OfferStoreSchema = yup.object().shape({
  name: yup.string().max(255).required().label('Título'),
  partner_id: yup.number().required().label('Parceira'),
  // partner_service_id: yup.number().nullable().label('Serviço'),
  service_id: yup.number().required().label('Serviço'),
  start_at: yup.date().nullable().label('Ínicio'),
  end_at: yup.date().nullable().label('Fim'),
  description: yup.string().required().label('Descrição Curta'),
  details: yup.string().label('Descrição Complementar'),
  image: yup.mixed().isFile().label('Imagem'),
  link: yup.string().max(255).required().label('Link'),
});

export const OfferUpdateSchema = yup.object().shape({
  name: yup.string().max(255).required().label('Título'),
  partner_id: yup.number().required().label('Parceira'),
  // partner_service_id: yup.number().required().label('Serviço'),
  service_id: yup.number().required().label('Serviço'),
  start_at: yup.date().nullable().label('Ínicio'),
  end_at: yup.date().nullable().label('Fim'),
  description: yup.string().required().label('Descrição Curta'),
  details: yup.string().label('Descrição Complementar'),
  image: yup.mixed().isFile().label('Imagem'),
  link: yup.string().max(255).required().label('Link'),
});
